import { Link as IntlLink } from 'gatsby-plugin-intl'
import { Text } from '@chakra-ui/react'
import * as React from 'react'

import { isPageType } from '../../context/LayoutContext'

type LinkProps = React.ComponentPropsWithoutRef<typeof IntlLink> & {}

const Link: React.FC<LinkProps> = ({ to, children, ...others }) => {
  const internal = to ? isPageType(to) : false

  return to && to !== '' ? (
    internal ? (
      <IntlLink to={to} {...others}>
        {children}
      </IntlLink>
    ) : (
      <Text as="a" href={to} target="_blank">
        {children}
      </Text>
    )
  ) : (
    <>{children}</>
  )
}

export default Link
